import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing, PasswordReset, SignIn, TeamRegistration, PlayerRegistration } from 'pages';
import { PAGES } from './constants';

export const Router = () => (
  <BrowserRouter>
    <Routes>
      <Route path={PAGES.HOME} element={<Landing />} />
      <Route path={PAGES.SIGN_IN} element={<SignIn />} />
      <Route path={PAGES.PASSWORD_RESET} element={<PasswordReset />} />
      <Route path={PAGES.TEAM_REGISTRATION} element={<TeamRegistration />} />
      <Route path={PAGES.PLAYER_REGISTRATION} element={<PlayerRegistration />} />
    </Routes>
  </BrowserRouter>
);
